module.exports = __webpack_public_path__ + "img/hero-bg.51132a36.svg";